import React from 'react'
import './App.css';

const Loader = () => {
  return (
    <div className="progress">
      
    </div>
  )
}

export default Loader
